<template>
  <section id="login">
    <v-layout align-center justify-center>
      <v-card class="elevation-5" width="600px" >
        <v-card-text class="pa-5">
          <v-img
            :src="require('@/assets/logo/alv-logo.png')"
            class="mb-3 mx-auto"
            width="80px"
          />
          <h3 class="text-center">{{ signInText }}</h3>
          <form @submit.prevent="submit">
            <v-text-field
              v-model="username"
              prepend-icon="person"
              :label="usernameLabel"
              name="username"
              v-bind:alvqa="'login-username'"
            />
            <v-text-field
              v-model="password"
              prepend-icon="lock"
              :label="passwordLabel"
              name="password"
              type="password"
              v-bind:alvqa="'login-password'"
            />
            <v-flex text-right>
              <v-btn 
                type="submit" 
                v-bind:alvqa="'login-submit'"
                :disabled="isLoading"
              >
                {{ loginButtonLabel }}
              </v-btn>
            </v-flex>
          </form>
        </v-card-text>
      </v-card>
    </v-layout>
  </section>
</template>

<script>
import api from '../api_alv'

export default {
  name: 'Login', 
  data() { 
    return {
      username: '',
      password: ''
    }
  }, 
  computed: {
    passwordLabel() { return "Password" }, // this.$t('lang_LOGIN_CAPTION_PASSWORD')
    usernameLabel() { return "User" }, // this.$t('lang_LOGIN_CAPTION_USERNAME')
    signInText() { return 'Login' }, // lang const?
    loginButtonLabel() { return "Login" }, // this.$t('lang_LOGIN_BUTTON_CAPTION_LOGIN')
    isLoading: {
      get() { return this.$store.getters.getIsLoading },
      set(value) { this.$store.commit('setIsLoading', value)}
    }
  },
  methods: {
    /** Logs the user in if username and password are correct.
     *  if credentials correct a token will be safed in localStorage and 
     *  the userdata will be stored. The account language will be loaded
     *  and a snackbar with a positiv message will be shown. 
     *  if incorrect a snackbar with a error message will be shown.
     *  
     *  @listens event:click
     */
    submit() {
      this.isLoading = true
      api.postLogin(this.username, this.password)
        .then(response => {  
            // Save userdata in localStorage, 'cause vuex will be empty after reload. 
            localStorage.setItem('userData', JSON.stringify(response))              
            // Set User Object in Vuex
            this.$store.commit('setUser', JSON.parse(localStorage.getItem('userData')).user)                      
            // Set UI lang to the lang from the user data (before that it was default for the login page)          
            // this.$store.dispatch('fetchI18nMessages', this.$store.getters.getUserLanguage)    

            // Mixpanel
            mixpanel.identify(this.$store.getters.getUser.id)
            mixpanel.track('Logging in as', {
              'userId': this.$store.getters.getUser.id,
              'userName': this.$store.getters.getUserUsername,
              'userCompany': this.$store.getters.getUserCustomerCompany,
            });
            // Set user properties in Mixpanel
            mixpanel.people.set({
            //'$email': this.$store.getters.getUserEmail, //need getter to add email
            '$last_login': new Date(), // Records the time of the login
            'Company': this.$store.getters.getUserCustomerCompany,
            'Username': this.$store.getters.getUserUsername,
            'Name': this.$store.getters.getUserUsername,
            'User Id': this.$store.getters.getUser.id,
            //'Group': this.$store.getters.getUser.Group, //need getter to add group
            //'Role': this.$store.getters.getUser.Role,  //need getter to add role
            // ... any other properties you want to track
            });

            this.$store.commit(
              'setSnackbar', 
              {
                type: 'success', 
                // removed lang const because they are not available yet at this stage
                msg: "Login was successful"
              }
            )

            this.$i18n.locale = this.$store.getters.getUserLanguage
            this.isLoading = false
            this.$router.push('/dashboard')
        })
        .catch(error => {
            this.isLoading = false
            this.$store.commit(
              'setSnackbar',
              {
                type: 'error',
                // removed lang const because they are not available yet at this stage
                msg: "Login was not successful. Please check username and password."
              }
            )
        })
    }
  },
  
// HOOKS
  beforeRouteEnter(to, from, next) {
    next(vm => { 
      // vm.$store.dispatch('fetchI18nMessages', 'de')
      if (vm.$store.getters.getIsLoggedIn) vm.$router.push('/dashboard') 
    })
    // $store.dispatch('fetchI18nMessages', 'de')
  }, 
}
</script>
